const removeTTWaterMark = {
  HitPawTikTokTitle: 'HitPaw Quitar Marca de Agua de TikTok Online',
  ExportVideoWithoutWaterMark: 'Exportar Video Sin HitPaw Marca de Agua',
  ProcessTiktokLinkWithoutLimits: 'Procesar URLs de TikTok Sin Limitación',
  FasterProcessingSpeed: '10X Velocidad de Procesamiento Más Rápida',
  PrioritySupport: 'Soporte de Prioridad',
  DiscountPrice: '0.99€',
  WeekTotalPrice: '4.49€',

  MonthWeekPrice: '1.75€',
  MonthTotalPrice: '6.99€',

  YearWeekPrice: '0.87€',
  YearTotalPrice: '41.88€',
  Day: 'Día',
  Monthly: 'Mensualmente',
  Weekly: 'Semanalmente',
  Yearly: 'Anualmente',
  week: 'Semana',
};

export default removeTTWaterMark;
